import type { MbcAdminGuideline } from "@nlc/shared-types";

import { Label } from "@/components/field";
import {
  Select,
  SelectButton,
  SelectListBox,
  SelectListItem,
  SelectPopover,
} from "@/components/select";

const INHERIT = "inherit";

interface GuidelineSelectProps {
  readonly allowInherit?: boolean;
  readonly guidelines: MbcAdminGuideline[];
  readonly onChange: (guidelineId: null | string) => void;
  readonly value: null | string;
}

export function GuidelineSelect({
  allowInherit = false,
  guidelines,
  onChange,
  value,
}: GuidelineSelectProps) {
  const options = [
    ...(allowInherit
      ? [{ id: INHERIT, name: "Inherit (no guideline of its own)" }]
      : []),
    ...guidelines.map(({ _id, name }) => ({ id: _id, name })),
  ];

  return (
    <Select
      onSelectionChange={(key) =>
        onChange(key === INHERIT ? null : String(key))
      }
      selectedKey={value ?? INHERIT}
    >
      <Label>Guideline</Label>
      <SelectButton />
      <SelectPopover>
        <SelectListBox items={options}>
          {(item) => (
            <SelectListItem id={item.id} textValue={item.name}>
              {item.name}
            </SelectListItem>
          )}
        </SelectListBox>
      </SelectPopover>
    </Select>
  );
}
